import { render, staticRenderFns } from "./KeyTerms.vue?vue&type=template&id=4f6b413c&scoped=true&"
import script from "./KeyTerms.vue?vue&type=script&lang=js&"
export * from "./KeyTerms.vue?vue&type=script&lang=js&"
import style0 from "./KeyTerms.vue?vue&type=style&index=0&id=4f6b413c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6b413c",
  null
  
)

export default component.exports